import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-emoticon",
  "use": "icon-si-glyph-emoticon-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-emoticon\" id=\"icon-si-glyph-emoticon\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>946</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M7.981,0.084 C3.596,0.084 0.042,3.639 0.042,8.022 C0.042,12.406 3.596,15.96 7.981,15.96 C12.364,15.96 15.917,12.406 15.917,8.022 C15.917,3.639 12.363,0.084 7.981,0.084 L7.981,0.084 Z M10.998,4 C12.106,4 13,4.894 13,6 C13,7.103 12.106,8 10.998,8 C9.897,8 9,7.103 9,6 C9,4.894 9.897,4 10.998,4 L10.998,4 Z M5,4 C6.104,4 7,4.896 7,6 C7,7.104 6.104,8 5,8 C3.896,8 3,7.104 3,6 C3,4.895 3.896,4 5,4 L5,4 Z M8,14 C4.987,14 3,12.101 3,10 L13,10 C13,12.101 11.012,14 8,14 L8,14 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-emoticon.svg
// module id = GyHu
// module chunks = 62